export default "__VITE_ASSET__DY$CHL5P__"